import {
  FinanceView,
  OrderBalanceView,
  PaymentApplyView,
  RemittanceView,
  PaymentOrderView,
  OrderContractView,

  OrderContractDetail,
  PaymentApplyDetail,
  RemittanceDetail,
} from "~/views/Finance";
import Layout from "~/layout/index.vue";

const FinanceRoutes = {
  path: "/finance",
  component: Layout,
  children: [
    {
      path: "",
      name: "finance",
      component: FinanceView,
      meta: {
        title: '财务管理',
        isBack: false,
        isHeaderShow: true
      }
    },
    {
      path: "orderBalance",
      name: "orderBalance",
      component: OrderBalanceView,
      meta: {
        title: '订单结算',
        isBack: true,
        isHeaderShow: true

      }
    },
    {
      path: "paymentApply",
      name: "paymentApply",
      component: PaymentApplyView,
      meta: {
        title: '付款申请',
        isBack: true,
        isHeaderShow: true
      }
    },
    {
      path: "remittance",
      name: "remittance",
      component: RemittanceView,
      meta: {
        title: '付汇单',
        isBack: true,
        isHeaderShow: true
      },
    },
    {
      path: "paymentOrder",
      name: "paymentOrder",
      component: PaymentOrderView,
      meta: {
        title: '付款单',
        isBack: true,
        isHeaderShow: true
      },
    },
    {
      path: "orderContract",
      name: "orderContract",
      component: OrderContractView,
      meta: {
        title: '内贸合同',
        isBack: true,
        isHeaderShow: true
      },
    },
    {
      path: 'orderContractDetail',
      name: 'orderContractDetail',
      component: OrderContractDetail,
      meta: {
        title: '内贸合同详情',
        isBack: true,
        isHeaderShow: true
      },
    },
    {
      path: 'paymentApplyDetail',
      name: 'paymentApplyDetail',
      component: PaymentApplyDetail,
      meta: {
        title: '付款申请详情',
        isBack: true,
        isHeaderShow: true
      },
    },
    {
      path: 'remittanceDetail',
      name: 'remittanceDetail',
      component: RemittanceDetail,
      meta: {
        title: '付汇详情',
        isBack: true,
        isHeaderShow: true
      },
    }
  ]
};

export { FinanceRoutes };
